import {
  styled,
  Tab,
  Tabs,
  useMediaQuery,
  useTheme,
  type SxProps,
  type TabProps,
} from '@mui/material';
import { flatSx } from '@ocodelib/mui';
import clsx from 'clsx';

interface Props {
  sx?: SxProps;
  className?: string;

  /**
   * 현재 탭
   */
  currentTab: string;

  /**
   * 액티브상태의 탭 색상
   */
  tabActiveColor?: string;

  /**
   * 탭목록
   */
  tabs: readonly { key: string; label: React.ReactNode }[];

  /**
   * 탭변경 이벤트 핸들러
   */
  onChangeTab?: (e: React.SyntheticEvent, tabKey: string) => void;
}

export function PageTabs(props: Props) {
  const { sx, className, tabActiveColor = '#000', currentTab, tabs, onChangeTab } = props;
  const theme = useTheme();
  const xsOrDown = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Tabs
      sx={flatSx(
        {
          minHeight: 0,
          height: '40px',
          '& .MuiTabs-indicator': {
            backgroundColor: tabActiveColor,
            display: 'none',
          },
          '& .MuiTab-root': {
            '& + .MuiTab-root': {
              ml: 0.5,
            },
          },
          '& .MuiTabs-flexContainer': {
            height: '40px',
          },
        },
        sx,
      )}
      variant={xsOrDown ? 'scrollable' : 'standard'}
      centered
      className={clsx('PageTabs-root', className)}
      value={currentTab}
      onChange={onChangeTab}
    >
      {tabs.map(({ key, label }) => (
        <MenuTab key={key} label={label} value={key} activeColor={tabActiveColor} />
      ))}
    </Tabs>
  );
}

type CustomTabProps = {
  activeColor?: string;
} & Omit<TabProps, 'disableRipple'>;

const MenuTab = styled((props: CustomTabProps) => <Tab disableRipple {...props} />, {
  shouldForwardProp: (prop) => prop !== 'activeColor',
})(({ theme, activeColor = '#000' }) => ({
  padding: '0 24px',
  // color: alpha(activeColor, 0.7),
  color: '#fff',
  '&.MuiButtonBase-root': {
    minHeight: 0,
    height: '100%',
  },
  '&.Mui-selected': {
    color: activeColor,
    backgroundColor: '#fff',
    borderRadius: '10px 10px 0px 0px',
    [theme.breakpoints.up('xs')]: {
      minWidth: 65,
      fontSize: '1rem',
      fontWeight: 500,
    },
    [theme.breakpoints.up('md')]: {
      minWidth: 90,
      fontSize: '1.125rem',
      fontWeight: 500,
    },
  },
  [theme.breakpoints.up('xs')]: {
    minWidth: 65,
    fontSize: '0.9rem',
    fontWeight: 500,
  },
  [theme.breakpoints.up('md')]: {
    minWidth: 90,
    fontSize: '1rem',
    fontWeight: 700,
  },
}));
